import { sectionType } from "../../../sectionType";
import { columnDefs, subtypeEnum, variantEnum } from "./models/column-definition";
import { columnType } from "./models/column-type.enum";
import { RowhouseColumn, RowhousePart } from "./models/props-config";
import { segmentType } from "./models/segment-type";
import { UnitAmount } from "../models/column";
import { partTypeEnum } from "./models/part-type.enum";
import { ColumnBaseService } from "../column-base.service";

export interface Config {
    amountOfHSColumns: number,
    amountOfHM1M2Columns: number,
    amountOfHLColumns: number,
    middleFloors: number,
}
export class ColumnService extends ColumnBaseService {

    getTotalAmountOfAllUnits(parts: RowhousePart[]): UnitAmount[] {
        let unitAmounts: UnitAmount[] = [];
        if (parts) {
            unitAmounts = this.computeTotalAmountsForParts(parts);
            const totalUnits = this.totalUnits(unitAmounts);

            unitAmounts.forEach(unitAmount => {
                unitAmount.percentage = unitAmount.amount / totalUnits * 100;
            });
        }
        return unitAmounts;
    }

    createPossibleColumnDefinitions(
        c: Config
    ): RowhousePart[] {

        const columnDefinitions: RowhouseColumn[] = [];

        if (c.amountOfHSColumns > 0) {
            for (let i = 0; i < c.amountOfHSColumns; i++) {
                columnDefinitions.push(
                    this.createColumnFromDefinition(columnType.H_S, c.middleFloors)
                )
            }
        }
        if (c.amountOfHM1M2Columns > 0) {
            for (let i = 0; i < c.amountOfHM1M2Columns; i++) {
                columnDefinitions.push(
                    this.createColumnFromDefinition(columnType.H_M1M2, c.middleFloors)
                )
            }
        }
        if (c.amountOfHLColumns > 0) {
            for (let i = 0; i < c.amountOfHLColumns; i++) {
                columnDefinitions.push(
                    this.createColumnFromDefinition(columnType.H_L, c.middleFloors)
                )
            }
        }

        const part: RowhousePart = {
            type: partTypeEnum.body,
            columns: columnDefinitions
        }

        return [part];
    }

    private totalUnits(units: UnitAmount[]): number {
        return units.map(u => u.amount).reduce((p, c) => p + c, 0);
    }

    private createColumnFromDefinition(type: columnType, middleFloors: number): RowhouseColumn {
        const defs = columnDefs;
        const columnDefinition = defs.find(s => s.type === type);
        const bays = columnDefinition.bays;

        let amountOfUnits = [];

        let middleSections: sectionType[];

        let midFloors = middleFloors;
        if (type === columnType.H_S) {
            midFloors = 2;
        }

        const middleDef = columnDefinition.segmentDefinitions.find(s => s.type === segmentType.middle && s.subtype === subtypeEnum.single);
        const middleFloorDef = middleDef.floorVariants.find(s => s.floors === midFloors);

        const middleSideDef = middleFloorDef.variants.find(f => f.variant === variantEnum.single);
        middleSections = middleSideDef.sections;

        let result: RowhouseColumn = {
            id: Math.random().toString(),
            type,
            bays,
            segments: [
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    sectionTypes: middleSections,
                    floorsInSegment: midFloors,
                },
            ],
            amountOfUnits,
        }

        return result;
    }
}